import { api } from './api';

export const getPlaylist = async () => {
  const {
    data: {
      data: { playlists },
    },
  } = await api.get('/playlist/index');
  return playlists;
};

export const savePlaylist = async (playlist_id: number, music_ids: string) => {
  await api.post('/playlist/add', { playlist_id, music_ids });
};

export const makeNewPlaylist = async (name: string) => {
  await api.post('/playlist/create', { playlist_name: name });
};
